import i18n from "@/locales/index"
export default [
  [
    {
      name: "reference",
      label: i18n.tc("purchaseOrder"),
      type: "text",
      placeholder: i18n.tc("purchaseOrder2"),
      required: false,
      size: {
        md: 6,
        lg: 3,
      },
    },
    {
      name: "comment",
      label: i18n.tc("comment"),
      type: "text",
      placeholder: i18n.tc("comment"),
      required: false,
      size: {
        md: 6,
        lg: 9,
      },
    },
  ],
]
